import { ReactNode, useMemo } from 'react';
import { motion } from 'framer-motion';
import { Box, Paper } from '@mui/material';
import { animationVariants } from './animations';

interface PageWrapperProps {
  children: ReactNode;
  bare?: boolean;
}

const PageWrapper = ({ children, bare = false }: PageWrapperProps) => {
  const selectedVariant = useMemo(() => {
    const variants = Object.values(animationVariants);
    const randomIndex = Math.floor(Math.random() * variants.length);
    return variants[randomIndex];
  }, []);

  return (
    <Box
      component={motion.div}
      initial={selectedVariant.initial}
      animate={selectedVariant.animate}
      exit={selectedVariant.exit}
      transition={{ duration: 0.4, ease: 'easeInOut' }}
      sx={bare ? {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        minHeight: '100vh',
      } : {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {bare ? children : (
        <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 600 }}>
          {children}
        </Paper>
      )}
    </Box>
  );
};

export default PageWrapper;
